import React from "react";
import { BookOpen, Scale, Handshake, ShieldCheck } from "lucide-react";

const ITEMS = [
  {
    icon: BookOpen,
    title: "Counsel-led",
    body: "Every brief is drafted, read and argued by the advocate on record — not delegated.",
  },
  {
    icon: Scale,
    title: "Restraint over Volume",
    body: "We accept a measured caseload each year so quality and attention are uncompromised.",
  },
  {
    icon: Handshake,
    title: "Plain-spoken Advice",
    body: "Honest assessments of merit, costs and timelines before you commit to litigation.",
  },
  {
    icon: ShieldCheck,
    title: "Confidentiality First",
    body: "Discreet handling of sensitive matters — particularly service and family causes.",
  },
];

export default function WhyChooseUs() {
  return (
    <section
      data-testid="why-section"
      className="section"
      style={{ backgroundColor: "#F9F6F0", borderTop: "1px solid #E2DCD0" }}
    >
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="ornament text-xs" style={{ letterSpacing: "0.28em", textTransform: "uppercase" }}>
            The Chamber&apos;s Promise
          </span>
          <h2 className="font-serif-display mt-6 text-4xl md:text-5xl" style={{ color: "#0A1128", fontWeight: 500, lineHeight: 1.1 }}>
            How a senior advocate&apos;s
            <br />
            <span style={{ fontStyle: "italic", color: "#7A2021" }}>practice should feel.</span>
          </h2>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px"
          style={{ backgroundColor: "#E2DCD0", border: "1px solid #E2DCD0" }}
        >
          {ITEMS.map((it) => {
            const Icon = it.icon;
            return (
              <div key={it.title} className="p-8 flex flex-col gap-5" style={{ backgroundColor: "#FFFFFF" }} data-testid={`why-item-${it.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <Icon size={26} strokeWidth={1.4} style={{ color: "#7A2021" }} />
                <h3 className="font-serif-display text-2xl" style={{ color: "#0A1128", fontWeight: 500 }}>{it.title}</h3>
                <p className="text-sm" style={{ color: "#334155", lineHeight: 1.7 }}>{it.body}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
